export default __webpack_public_path__ + "1870c9d1d1ed5c65a20929155e8df990.svg";